module.exports = __webpack_public_path__ + "static/media/members-upper-banner.80e1fd4d.png";